import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.specials__marquee' ).length ) {
        $( '.specials__marquee' ).each( function( index, element ) {
          const marqueeText = $( element ).find( '.specials__marquee-text .marquee-text' );
          let marqueeTextWidth = 0;
          marqueeText.each( function( index, el ) {
            marqueeTextWidth = marqueeTextWidth + $( el ).outerWidth();
          } );
          const slider = new Splide( element, {
            type: 'loop',
            drag: 'free',
            gap: '2rem',
            arrows: false,
            fixedWidth: `${marqueeTextWidth}px`,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'specials', COMPONENT );
} )( app );
